import React, { useState, useEffect } from 'react';
import { graphql } from 'gatsby';

const Document = ({ data }) => {
  const node = data.allMediaDocument.nodes[0];

  useEffect(() => {
    // download on load
    window.location.href =
      node.relationships.field_media_document.localFile.publicURL;
  }, [data]);

  const [counter, setCounter] = useState(3);
  useEffect(() => {
    if (counter > 0) {
      setTimeout(() => {
        setCounter(counter - 1);
      }, 1000);
    }
  }, [counter]);

  return (
    <section style={{ padding: '60px 30px' }}>
      <div className="m-auto" style={{ maxWidth: 500 }}>
        <h3>
          Download will begin automatically, but use the link below if
          necessary.
        </h3>
        <a
          href={
            node.relationships.field_media_document.localFile
              .publicURL
          }
          className={`btn ${counter ? 'disabled' : ''}`}
        >
          {counter ? `Wait ${counter} seconds` : 'Download'}
        </a>
      </div>
    </section>
  );
};

export default Document;

export const query = graphql`
  query($id: String!) {
    allMediaDocument(filter: { id: { eq: $id } }) {
      nodes {
        id
        drupal_internal__mid
        path {
          alias
        }
        relationships {
          field_media_document {
            filemime
            localFile {
              publicURL
            }
          }
        }
      }
    }
  }
`;
